// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(/ssr/css/second_style.css);"]);
// Module
exports.push([module.id, "\n.subtitle[data-v-f644626c] {\n  font-size: 16px;\n  color: #666;\n  margin-bottom: 30px;\n}\n.card[data-v-f644626c] {\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n  padding: 30px;\n  margin-bottom: 20px;\n}\n/* ... (include other styles from the original HTML) ... */\n", ""]);
// Exports
module.exports = exports;
